export interface HttpStatusError {
  status: number;
}
export const isHttpStatusError = (error: unknown): error is HttpStatusError =>
  !isNaN((error as HttpStatusError).status);
